// <!--version 0.9.02-->
//   <!--//@*/*
//   //    *RPD Loiter Appv0.91
//   //    * Copyright (c) 2024, Blue Cover Six LLC . All rights reserved.
//   //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
//   //    */
//   //-->

/* eslint-disable */

const home = () => import("../components/home.vue");

const pagenoutfound = () => import("../components/pagenoutfound.vue");

export const routes = [
  {
    name: "home",
    path: "/",
    component: home,
    display: "home",
  },

  { name: "not-found", path: "/:pathMatch(.*)*", component: pagenoutfound },
];
